import { client } from "api";
import { Department } from "models/Department";

export type CreateDepartmentRequest = { name: string };

export type CreateDepartmentResponse = Department[];

export const createDepartment = (data: CreateDepartmentRequest) =>
  client.post<CreateDepartmentResponse>(`/department`, data).then((res) => res.data);
